import { render, staticRenderFns } from "./areasList.vue?vue&type=template&id=7b60bc1a&"
import script from "./areasList.vue?vue&type=script&lang=js&"
export * from "./areasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports